import type { IArticle } from '@modules/articles/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  ARTICLES_LIST_QUERY_KEY,
  ARTICLES_PERMISSIONS,
} from '@modules/articles/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  ARTICLES_SAVE_MUTATION_KEY,
  ARTICLES_SAVE_URL,
} from '../constants';

export default function useArticleSaveMutation(): IContextMutationResult<
  void,
  Error,
  IArticle
> {
  const { fetchPut, fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  function getFetch(article: IArticle): Promise<void> {
    if (article.id) {
      return fetchPut<void>(
        ARTICLES_SAVE_URL,
        { article },
        {
          permission: ARTICLES_PERMISSIONS.UPDATE,
          urlParams: {
            id: article.id,
          },
        },
      );
    }

    return fetchPost<void>(
      ARTICLES_SAVE_URL,
      { article },
      {
        permission: ARTICLES_PERMISSIONS.CREATE,
        urlParams: {
          id: '',
        },
      },
    );
  }

  return useContextMutation<void, Error, IArticle>({
    mutationKey: [ARTICLES_SAVE_MUTATION_KEY],
    mutationFn: async (article) => getFetch(article),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [ARTICLES_LIST_QUERY_KEY] });

      displayPresetToast(variables.id ? 'edited' : 'created');
    },
  });
}
